import { EVariantSource } from 'GeneDashboardView/components/ExternalVariantSources/types';
export var ExternalVariantSource;
(function (ExternalVariantSource) {
    ExternalVariantSource["OMIM"] = "omim";
    ExternalVariantSource["HGMD"] = "hgmd";
    ExternalVariantSource["CLIN_VAR"] = "clinvar";
    ExternalVariantSource["EBI_GWAS"] = "ebigwas";
    ExternalVariantSource["GBMI"] = "gbmi";
})(ExternalVariantSource || (ExternalVariantSource = {}));
